export default {"src":"/_next/static/media/calendarTooth_40.5c9a10c9.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};